export const CLUBBED_LEVELS = [
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/sword.png',
    openLevel: 0,
    closeLevel: 5,
    name: 'Mortal',
  },
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/mask.png',
    openLevel: 6,
    closeLevel: 10,
    name: 'Hero',
  },
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/amulet.png',
    openLevel: 11,
    closeLevel: 15,
    name: 'Warrior',
  },
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/lantern.png',
    openLevel: 16,
    closeLevel: 20,
    name: 'Demigod',
  },
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/ring.png',
    openLevel: 21,
    closeLevel: 25,
    name: 'Champion',
  },
  {
    img: 'https://d2kqzc4rviquge.cloudfront.net/public/xion/armory.png',
    openLevel: 26,
    closeLevel: 30,
    name: 'Divine Spirit',
  },
];
